import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router'
import store from '@/store'


// 全局引入vuex
import mixin from '@/store/$u.mixin.js' // 导入修正后的混入
Vue.mixin(mixin) // 全局注册

import api from "./utils/api/index";
Vue.prototype.$api = api;

Vue.use(ElementUI);
Vue.config.productionTip = false

new Vue({
  store,
  router, // 注入路由实例
  el: '#app',
  render: h => h(App),
}).$mount('#app')
